import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButtons from '../components/CustomButtons';
import styles from '../assets/css/member-registration.module.css';

function UpdateCompletePage() {
  const navigate = useNavigate();
  return (
    <div className={styles.mainContents}>
      <div className={styles.container}>
        <div className={styles["registration-card"]}>
          <h1 className={`${styles["text-primary"]} text-center mb-4`}>更新完了</h1>
          <p className="text-center mb-4">メンバー情報の更新が完了しました。</p>

          <CustomButtons
            rightLabel="マイページへ戻る"
            onRightClick={() => navigate('/')}
            leftLabel=""
            leftClassName="d-none"
          />
        </div>
      </div>
    </div>
  );
}

export default UpdateCompletePage;